<script lang="js">
  /**
   * FAB Link.
   * - This is where the fab link is created.
   *
   * @param {Object} fab_item - The fab item object.
   * @param {String} classNames - The class names of the fab.
   * @param {Boolean} tooltipDisplay - Whether the tooltip is displayed.
   */
  import { onMount, onDestroy } from "svelte";
  import { createEventDispatcher } from "svelte";
  import FABLink from "../../helper/link";
  import FABLinkTooltip from "../../helper/link-tooltip";
  import { detect_hotkey } from "../../../library/function/browser";
  export let fab_item = {};
  export let classNames = "fab-links ";

  // Transform FAB Item.
  fab_item.classNames = classNames;

  // Variables.
  const dispatch = createEventDispatcher();
  let { fab_design } = window.FAB_PLUGIN.options;
  let styles = FABLink.get_styles_object(fab_item);
  let tooltipDisplay = fab_item.tooltipDisplay ?? false;

  // Event: Handle click.
  function handle_click(e) {
    const { fab_item } = e.detail;
    FABLink.handle_click_analytics(fab_item);
    dispatch("click", { fab_item });
  }

  // Event: Detect hotkey.
  if (fab_item?.hotkey) {
    detect_hotkey(fab_item.hotkey, (e) => {
      jQuery("#fab-link-" + fab_item.ID).click();
    });
  }

  // onMount
  onMount(() => {
    // Register On Click Event, we use jQuery to handle the click event.
    FABLink.register_on_click_event(fab_item);

    // Register event listener to handle on click event from jQuery.
    window.addEventListener(`fab-link-${fab_item.ID}`, handle_click);
  });

  // onDestroy
  onDestroy(() => {
    window.removeEventListener(`fab-link-${fab_item.ID}`, handle_click);
  });
</script>

{#if fab_item}
  <a
    id={`fab-link-${fab_item.ID}`}
    title={fab_item.title}
    href={fab_item.linkHref ? fab_item.link : undefined}
    target={fab_item.linkBehavior === "yes" ? "_blank" : undefined}
    class={FABLink.get_class(fab_item)}
    class:px-6={fab_design.template.name !== "shape" && tooltipDisplay}
    class:pl-3={fab_design.layout.position !== "right" && fab_design.template.name === "shape" && tooltipDisplay}
    style={FABLink.get_styles(fab_item, tooltipDisplay)}
    data-id={fab_item.ID ? fab_item.ID : undefined}
    on:mouseenter={() => {
      tooltipDisplay = true;
    }}
    on:mouseleave={() => {
      tooltipDisplay = fab_item.tooltip.alwaysdisplay ? true : false;
    }}
  >
    {#if fab_item.icon_class}
      <div
        class="fab-container-icon flex flex-col h-auto p-3 items-center place-content-center cursor-pointer {styles
          .button.shape}"
        class:simptip-position-right={fab_design.layout.position === "left"}
        class:simptip-position-left={fab_design.layout.position !== "left"}
      >
        <slot name="icon">
          <em class="relative {fab_item.icon_class}" style="color: {styles.icon.color}"></em>

          <div
            class="bg-shape"
            class:fab-bg-shape-active={fab_design.template.name === "shape"}
            style="--background-color: {styles.button.color}"
          ></div>
        </slot>
      </div>
    {/if}
    {#if styles.tooltip.label}
      <span
        class={FABLinkTooltip.get_tooltip_class(styles)}
        style={FABLinkTooltip.get_tooltip_styles(styles, tooltipDisplay)}
        class:pr-2={fab_item.icon_class}
        class:hidden={!tooltipDisplay}
      >
        <slot name="label">
          {styles.tooltip.label}
        </slot>
      </span>
    {/if}
  </a>
{/if}
